import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type IModalComponentName =
  | 'about'
  | 'approver-select'
  | 'billcode-change'
  | 'cats-info'
  | 'confirm'
  | 'contract-select'
  | 'default-change'
  | 'entity-number-lookup'
  | 'need-help'
  | 'nonbillable-select'
  | 'simple-text'
  | 'split'
  | 'spinner'
  | 'time-eval'
  | 'timesheet-create-or-edit'
  | 'timesheet-move'
  | 'timesheet-select'
  | 'vertical-bulk-add-per-diem'
  | 'per-diem-totals';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css',
  standalone: false,
})
export class ModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      component: IModalComponentName;
      data: any;
    },
    private readonly dialogRef: MatDialogRef<ModalComponent>,
  ) {}

  public ngOnInit(): void {
    this.dialogRef.backdropClick().subscribe({
      next: () => {
        this.handleClose(null);
      },
      error: (err) => {
        console.error('Error in backdropClick subscription:', err);
      },
    });
  }

  public handleClose(value?: any): void {
    this.dialogRef.close(value);
  }
}
